import {createAnalytics} from '../platform/analytics.js';

export const JournalAnalyticsEvent=Object.freeze({
  SESSION_CREATE_STARTED:'session_create_started',ITEM_ADDED:'item_added',STAGE_ADDED:'stage_added',SESSION_SAVED_AS_PLANNED:'session_saved_as_planned',SESSION_EDIT:'session_edit',SESSION_DELETED:'session_deleted',VALIDATION_ERROR:'validation_error'
});

const ALLOWED=Object.freeze(Object.values(JournalAnalyticsEvent));
const PRIVATE_KEYS=new Set(['note','notes','content','description','title','name','nameSnapshot','photo','photos','media','path','url','email']);

function dimensions(input={}){
  const out={};
  for(const [key,value] of Object.entries(input||{})){
    if(PRIVATE_KEYS.has(key))continue;
    if(['string','number','boolean'].includes(typeof value))out[key]=value;
  }
  return out;
}

export function createJournalAnalytics({consent,sink,appVersion='unknown',platform='web'}={}){
  const analytics=createAnalytics({allowedEvents:ALLOWED,consent,sink,dimensions:{app_version:String(appVersion),platform:String(platform)}});
  return Object.freeze({
    track(name,properties={}){return analytics.track(name,dimensions(properties));},
    events:JournalAnalyticsEvent
  });
}
